import { HTTPMethod } from '@perpay-web/constants/httpMethods';
import { useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import {
    submitDefaultAddress,
    submitDefaultAddressError,
    submitDefaultAddressReset,
    submitDefaultAddressSuccess,
} from '@perpay-web/fintech/actions/entities/defaultAddress';
import { USER_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { authenticatedJsonFetch } from '@perpay-web/fintech/utils/requestHandlers';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const useSubmitDefaultAddressDataModule = () => {
    const dataModule = useDataModule((payload) =>
        authenticatedJsonFetch(USER_ENDPOINT, payload, HTTPMethod.patch),
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: submitDefaultAddress,
        error: submitDefaultAddressError,
        success: submitDefaultAddressSuccess,
        reset: submitDefaultAddressReset,
    });

    return dataModule;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useSubmitDefaultAddressDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UseSubmitDefaultAddressDataModuleProvider,
    useSubmitDefaultAddressContext,
] = createContextProvider(providerFactory);
